/**
 * Figures i18n 配置
 */
import { addLocaleMessages } from '@/i18n';

import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import zhTW from './locales/zh-TW';
import jaJP from './locales/ja-JP';

// 注册 figures 模块的多语言包
addLocaleMessages('cn', zhCN);
addLocaleMessages('en', enUS);
addLocaleMessages('tw', zhTW);
addLocaleMessages('jp', jaJP);
